import {useQuery} from "@apollo/client";
import {getPlans} from "./PlanQueries";
import {Col} from "react-bootstrap";
import {Fragment} from "react";
import Loader from "../shared/Loader";

const Pricing = () => {
  const { data, loading } = useQuery(getPlans)

  if (loading) return <Loader />;

  return (
    <main>
      <div className="row row-cols-1 row-cols-md-4 mb-3 text-center mt-5">
        {data.plans && data.plans.map(
          (plan, index) => {
            return (
              <Col key={`plan-${index}`}>
                <div className="card mb-4 rounded-3 shadow-sm">
                  <div className="card-header py-3">
                    <h4 className="my-0 fw-normal">{plan.name}</h4>
                  </div>
                  <div className="card-body">
                    <h1 className="card-title pricing-card-title">{plan.price}<small
                      className="text-body-secondary fw-light">lei/mo</small></h1>
                    <ul className="list-unstyled mt-3 mb-4">
                      <li>
                        {plan.usersLimit}
                        {' '}
                        {plan.usersLimit === 1 ? 'client' : 'clienti'}
                      </li>
                      <li>
                        {plan.menusLimit}
                        {' '}
                        {plan.menusLimit === 1 ? 'meniu' : 'meniuri'}
                      </li>
                      {plan.price !== 0.00 && <li>Suport prin email</li>}
                      {/*<li>Rapoarte</li>*/}
                    </ul>
                    {plan.active && <Fragment>
                      {plan.price === 0.00
                        ?
                        <a type="button" className="w-100 btn btn-lg btn-outline-primary"
                           href={`/register/${plan.id}`}>
                          Sign up for free
                        </a>
                        :
                        <a type="button" className="w-100 btn btn-lg btn-primary"
                           href={`/register/${plan.id}`}>
                          {plan.price === 0.00 ? 'Sign up for free' : 'Inregistrare'}
                        </a>
                      }
                    </Fragment>
                    }
                  </div>
                </div>
              </Col>
            )
          }
        )}
      </div>
      <div className='text-center mb-5 fs-5'>
        Pentru planuri customizate, va rugam sa ne <a href="/contact">contactati</a>
      </div>

      {/*<h2 className="display-6 text-center mb-4">Compare plans</h2>*/}

      {/*<div className="table-responsive">*/}
      {/*  <table className="table text-center">*/}
      {/*    <thead>*/}
      {/*    <tr>*/}
      {/*      <th style={{width: '34%'}}></th>*/}
      {/*      <th style={{width: '17%'}}>Free</th>*/}
      {/*      <th style={{width: '17%'}}>Standars</th>*/}
      {/*      <th style={{width: '17%'}}>Expert</th>*/}
      {/*      <th style={{width: '17%'}}>Nelimitat</th>*/}
      {/*    </tr>*/}
      {/*    </thead>*/}
      {/*    <tbody>*/}
      {/*    <tr>*/}
      {/*      <th scope="row" className="text-start">Public</th>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*    </tr>*/}
      {/*    <tr>*/}
      {/*      <th scope="row" className="text-start">Private</th>*/}
      {/*      <td></td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*    </tr>*/}
      {/*    </tbody>*/}

      {/*    <tbody>*/}
      {/*    <tr>*/}
      {/*      <th scope="row" className="text-start">Permissions</th>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*    </tr>*/}
      {/*    <tr>*/}
      {/*      <th scope="row" className="text-start">Sharing</th>*/}
      {/*      <td></td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*    </tr>*/}
      {/*    <tr>*/}
      {/*      <th scope="row" className="text-start">Unlimited members</th>*/}
      {/*      <td></td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*    </tr>*/}
      {/*    <tr>*/}
      {/*      <th scope="row" className="text-start">Extra security</th>*/}
      {/*      <td></td>*/}
      {/*      <td></td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*      <td>*/}
      {/*        <i className="bi bi-check" width="24" height="24"/>*/}
      {/*      </td>*/}
      {/*    </tr>*/}
      {/*    </tbody>*/}
      {/*  </table>*/}
      {/*</div>*/}
    </main>
  )
}

export default Pricing
